import React from 'react';
import {
  Box,
  MobileDrawer,
  MobileDrawerItem,
  Typography,
} from '@saviynt/design-system';
import cx from 'classnames';
import PropTypes from 'prop-types';

import './CertsTileActionsDrawer.css';

function CertsTileActionsDrawer({
  isActionDrawerOutsideClick,
  reusableActionsMap,
  isTileActionDrawerOpen,
  setIsTileActionDrawerOpen,
  tileCheckIcon,
  titleValue,
  tileKindHeading,
  handleTileClick,
  bulkSelectInfoForDrawer,
  checkSidePanelMobileFooter,
}) {
  const handleDrawerClose = () => {
    setTimeout(() => {
      setIsTileActionDrawerOpen(false);
    }, 250);
  };

  const getCheckBoxLabelForDrawer = (isChecked, count, isChildChecked) => {
    if (isChecked && count > 0 && isChildChecked)
      return 'Unelect Multiple Items';

    if (isChecked) return 'Unselect Item';

    if (count > 0) return 'Select Multiple Items';

    return 'Select Item';
  };

  const mobileDrawerClasses = cx(
    checkSidePanelMobileFooter &&
      'CertsTileActionsDrawer-mobileDrawer-sidePanelMobileFooter'
  );

  return (
    <MobileDrawer
      className={mobileDrawerClasses}
      isOpen={isTileActionDrawerOpen}
      setIsOpen={setIsTileActionDrawerOpen}
      isSwipeEnabled
      // Add any Modals or other drawers that should block outside click
      isOutsideClickEnabled={isActionDrawerOutsideClick}
      content={
        <Box className='CertsTileActionsDrawer'>
          <Box className='CertsTileActionsDrawer-header'>
            {!checkSidePanelMobileFooter && (
              <Box className='CertsTileActionsDrawer-drawerActionsIcon'>
                {tileCheckIcon}
              </Box>
            )}
            <Box className='CertsTileActionsDrawer-text'>
              <Typography kind='h4' mobile='h4-d'>
                {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                {checkSidePanelMobileFooter
                  ? 'All Actions'
                  : `${tileKindHeading}: ${titleValue}`}
              </Typography>
            </Box>
          </Box>
          {reusableActionsMap}
          {!checkSidePanelMobileFooter && (
            <>
              <MobileDrawerItem
                option={{
                  label: getCheckBoxLabelForDrawer(
                    bulkSelectInfoForDrawer?.isChecked,
                    bulkSelectInfoForDrawer?.childCount,
                    bulkSelectInfoForDrawer?.isAtleastOneChildChecked
                  ),
                  value: 'select-multiple-items',
                  isChecked: bulkSelectInfoForDrawer?.isChecked,
                  isDisabled: !bulkSelectInfoForDrawer?.isBulkActionEnabled,
                }}
                onClick={() => {
                  bulkSelectInfoForDrawer.handleBulkSelectFromDrawer();
                  handleDrawerClose();
                }}
              />
              <MobileDrawerItem
                option={{
                  label: 'See details',
                  value: 'see-details',
                  suffixIcon: 'ChevronRightSmall',
                  isChecked: false,
                  isDisabled: false,
                }}
                onClick={(e) => {
                  handleTileClick(e);
                  handleDrawerClose();
                }}
                className='CertsTileActionsDrawer-seeDetailsItem'
              />
            </>
          )}
        </Box>
      }
    />
  );
}

CertsTileActionsDrawer.propTypes = {
  isActionDrawerOutsideClick: PropTypes.bool.isRequired,
  reusableActionsMap: PropTypes.element.isRequired,
  isTileActionDrawerOpen: PropTypes.bool.isRequired,
  setIsTileActionDrawerOpen: PropTypes.func.isRequired,
  tileCheckIcon: PropTypes.element.isRequired,
  titleValue: PropTypes.string.isRequired,
  tileKindHeading: PropTypes.string.isRequired,
  handleTileClick: PropTypes.func.isRequired,
  checkSidePanelMobileFooter: PropTypes.bool.isRequired,
  bulkSelectInfoForDrawer: PropTypes.shape({
    isChecked: PropTypes.bool,
    childCount: PropTypes.number,
    isBulkActionEnabled: PropTypes.bool,
    isAtleastOneChildChecked: PropTypes.bool,
    handleBulkSelectFromDrawer: PropTypes.func,
  }),
};

CertsTileActionsDrawer.defaultProps = {
  bulkSelectInfoForDrawer: {
    isChecked: false,
    childCount: 0,
    isBulkActionEnabled: false,
    isAtleastOneChildChecked: false,
    handleBulkSelectFromDrawer: () => {},
  },
};

export default CertsTileActionsDrawer;
